import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { FileFormatter } from '@repo/toolkit/file'
import { FileTypeEnum, IFile } from '@repo/toolkit/types'
import Modal from '@repo/ui/modal'
import Typography from '@repo/ui/typography'
import { ReactNode } from 'react'

import { DisplayImage } from '../../../../../packages/ui/components/atoms/input/file/display-image'
import { useModalManager } from '../../lib/hooks/use-modal-manager'

type Props = {
  file: IFile
  imageSizeVariant?: 'small' | 'large'
  informationSection?: ReactNode
  label?: string
  actions?: ReactNode
}

const DisplayImageInfo = ({
  file,
  label,
  informationSection,
  actions,
  imageSizeVariant = 'small'
}: Props) => {
  const { modalState, toggleModal } = useModalManager<'image-preview'>(['image-preview'])

  return (
    <div
      className={
        'flex w-full items-center justify-between p-2 bg-white-active border border-grey-light rounded-lg '
      }
    >
      <div className={'flex flex-1 items-center gap-5'}>
        <DisplayImage
          type={file.type}
          src={file.path}
          onImagePreview={() => toggleModal('image-preview')}
          className={cn('rounded-sm object-cover  ', {
            'h-12 w-12': imageSizeVariant === 'small',
            'h-16 w-16 rounded-lg': imageSizeVariant === 'large'
          })}
        />
        <div className={'flex flex-col justify-center gap-1'}>
          <Typography variant={'tag'} color={tailwindColors.grey.DEFAULT} className="break-all">
            {label ?? file.name}
          </Typography>
          {informationSection}
          <Typography variant={'label-medium'} color={tailwindColors.grey.light.active}>
            {FileFormatter.size(file).value}
          </Typography>
        </div>
      </div>
      {actions}

      <Modal
        isOpen={modalState['image-preview']}
        hideActions
        size={
          file.type === FileTypeEnum.PDF || file.type === FileTypeEnum.XML ? 'large' : 'medium'
        }
        hideHeader
        onCancel={() => toggleModal('image-preview')}
      >
        <DisplayImage
          allowAll
          type={file.type}
          src={file.path}
          className={cn(
            'h-fit p-1 w-full rounded-xl object-cover relative z-10 overflow-auto object-fit',
            { 'h-[80vh] ': file.type === FileTypeEnum.PDF || file.type === FileTypeEnum.XML }
          )}
        />
      </Modal>
    </div>
  )
}

export default DisplayImageInfo
